import React, { Component } from "react";
import {Media,MediaLeft,MediaContent,
  Title,Column,Subtitle,Box} from 'bloomer'
import {omit} from 'lodash/fp';
import {keys} from 'lodash'
import PropTypes from "prop-types";
import ShortUniqueId from "short-unique-id";

const uuid = new ShortUniqueId();
const prepareProfile = omit(['description','name','image'])


class ProfileItem extends Component
{
  constructor(){
    super()
    this.handleClick= this.handleClick.bind(this);
  }

  handleClick(e){
    e.preventDefault()
    const {onClick,profile} = this.props;
    onClick && onClick(profile)
  }

  render() {
    const {profile,defaultImage} = this.props;
    const profileKeys=keys(prepareProfile(profile));
    const image = (profile.image && profile.image.src && profile.image) || defaultImage;
    const uniqueKey = uuid.randomUUID(7)
    return (
      <Column isSize={4}>
        <Box>
        <Title isSize={6}>{profile.name}</Title>
        <Media>
          {image &&
          <MediaLeft>
            <figure className="image is-64x64">
              <img
                className="is-rounded"
                src={image.src}
                alt={image.alt}/>
            </figure>
          </MediaLeft>
          }
          <MediaContent>
            {
                  Array.isArray(profileKeys)&&
                  profileKeys.length &&
                  profileKeys.map((profileKey,index)=>(
                    <Subtitle className='is-marginless' isSize={6} key={`${uniqueKey}-${index}`}>
                      <strong>{profileKey}:</strong><br/>
                      {profile[profileKey]}
                    </Subtitle>
                    ))
            }
          </MediaContent>
        </Media>
        </Box>
      </Column>
    );
  }
}

ProfileItem.propTypes = {
  profile:PropTypes.object,
  onClick:PropTypes.func,
  defaultImage: PropTypes.shape({
    alt:PropTypes.string,
    src:PropTypes.string
  }),
};

ProfileItem.defaultProps = {};

export default ProfileItem;

